import React, { useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Container, Content} from 'rsuite';
//
import Query from "./Query";
import ResultsListView from "./ResultsListView";
import CalendarView from "./CalendarView";
import Search from "./search/Search";
import { RootState } from "../services/rootReducer";
import { setFreeTextSearch, executeSearchWithNavigation } from "../services/Search_Slice";
import { calRangeType, setShowDebugInfo, setType, selectCalendarRange, selectViewType } from "../services/View_Slice";
import CONSTANTS from '../constants';
//
//import ErrorBoundary from "../AppErrorBoundary";
//
import logger from '../loggers/logger';
import { format, parseISO } from 'date-fns';
//
import styles from "./css/QrastMain.module.css";
interface Dictionary<T> {
    [Key: string]: T;
  }
  
type screenValues = {
  mobile: boolean,
  width: number
}

function QrastMain(props: React.PropsWithChildren<screenValues>) {

    const dispatch = useDispatch();

    const viewType = useSelector(selectViewType);
    const { calRangeUsed, calRangeValue } = useSelector(selectCalendarRange);
    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // const {urls} = useSelector((state: RootState) => state.Download);
    const freeTextSearch = useSelector((state: RootState) => state.Search.freeTextSearch);

    const usedContainer = props.mobile ? styles.container_mobile: styles.container

    // Memoize expensive date calculations — only recalculate when calRangeUsed/calRangeValue change
    const anInitialDate = useMemo(() => {
      var adate: Date | undefined = undefined;

      if(calRangeUsed !== undefined){
        switch(calRangeUsed){
            case calRangeType.month:
                adate = parseISO(String(calRangeValue+"-01"));
                break;
            case calRangeType.year:
                adate = parseISO(String(calRangeValue+"-01-01"));
                break;
            case calRangeType.week:
                adate = parseISO(String(calRangeValue));
                break;
            default:
                break;
        }
      }

      if(adate !== undefined){
        if(calRangeUsed===calRangeType.year){
          return format(adate, 'yyyy');
        }else if(calRangeUsed===calRangeType.month){
          return format(adate, 'yyyy-MM');
        }else if(calRangeUsed===calRangeType.week){
          return format(adate, 'yyyy-MM-dd');
        }
      }

      if(calRangeUsed===calRangeType.year){
        return format(new Date(), 'yyyy');
      }else if(calRangeUsed===calRangeType.month){
        return format(new Date(), 'yyyy-MM');
      }else if(calRangeUsed===calRangeType.week){
        return format(new Date(), 'yyyy-MM-dd');
      }
      return "";
    }, [calRangeUsed, calRangeValue]);


    // when search free text field is triggered
    const doSearch = React.useCallback((criteria: string) => {
      // hidden feature: shows debug info
      if (criteria==='hack: show debug info'){
        //logger.info("#### doSearch; SHOW DEBUG INFO");
        dispatch(setShowDebugInfo(true));
      }else if(criteria==='hack: hide debug info'){
        //logger.info("#### doSearch; hide DEBUG INFO");
        dispatch(setShowDebugInfo(false));
      }else if(criteria==='hack: help'){
        //logger.info("#### doSearch; help");
        //logger.info("#### doSearch; 'hack: show debug info': show debug info");
        //logger.info("#### doSearch; 'hack: hide debug info':hide debug info");
      }else if(criteria === '' || criteria.trim().length === 0) {
        // Clear search and navigate to calendar view
        dispatch(setFreeTextSearch(''));
        dispatch(setType(1)); // 1 = Calendar view
      }else{
        // Normal search case: use coordinated thunk to prevent multiple queries
        dispatch(executeSearchWithNavigation(criteria));
      }
    }, [dispatch]);

    return (
        <Container fluid="true" className={usedContainer}>
          {/**/}
          <Search value={freeTextSearch} callback={doSearch} popupColor={'#c2c2c2'} placeHolder={"Search for..."}/>
          <Query/>
          <Content className={styles.glContent}>
            { viewType===0 ?
              <ResultsListView width={props.width} mobile={props.mobile}/>
              :
              <div className={styles.calendar}>
                <CalendarView width={props.width} mobile={props.mobile}/>
              </div>
            }
          </Content>
        </Container>
    )
}

export default React.memo(QrastMain);